<template>
  <div>
    <div id="aaa"></div>
    <van-nav-bar 
      fixed
      title="库存列表" 
      left-arrow 
      @click-left="onClickLeft"
    />
    <div id="bbb"></div>
    <!--搜索开始-->
    <van-row style="width: 100%;top: 37px;position:fixed;z-index: 10000;">
      <van-col span="24">
        <form action="/">
          <van-search
            v-model="value"
            placeholder="耗材名称/品牌"
            show-action
            shape="round"
            @search="onSearch"
            >
            <div slot="action" @click="onSearch(value)">搜索</div>
          </van-search>
        </form>
      </van-col>
    </van-row>

    <!--搜索结束-->

    <!--导航栏开始-->
    <van-tabs v-model="activeName" :border="false" sticky :offset-top="87" @click="changeCk">
      <van-tab
        v-for="(cangku_item,cangku_index) in cangku" 
        :key='cangku_index'  
        :title="cangku_item.warehouse_name" 
        :name="cangku_item.warehouse_name"
        >
        <van-row v-if="parseTabbarAll[0]" type="flex" >
          <van-col span="5">
            <van-sidebar  v-model="activeKey" @change="onChange" :style="classObject">
              <van-sidebar-item  v-for="(item,index) in category" :key='index' :title='item.category_name'/>
            </van-sidebar>
          </van-col>
          <van-col span="18" :style="classObject">
            <div 
              class="van-cell-group van-hairline--top-bottom van-panel"  style="position: relative;"
              v-for="(consumable, index) in parseTabbarAll " 
              :key='index'
              @click="selectedItem(consumable)"
              >
              <div class="van-cell van-panel__header" v-if="cangku_item.warehouse_name=='全部' || consumable.warehouse_name==cangku_item.warehouse_name">
                <div class="van-cell__title">
                  <div><span>{{consumable.modelname}}</span></div>
                  <div class="van-cell__label ">品牌：{{consumable.brandname}}</div>
                  <div class="van-cell__label ">仓库：{{consumable.warehouse_name}}</div>
                  <div class="van-cell__label" v-if="consumable.is_gift!=1"><van-tag plain type="warning">赠品</van-tag></div>
                </div>
                <div class="van-cell__value van-panel__header-value" >
                  <span>{{consumable.quantity + consumable.unit}}</span>
                </div>
              </div>
            </div>
          </van-col>
        </van-row>
        <van-empty v-else description="暂无数据" />
      </van-tab>
    </van-tabs>
     
  </div>
</template>

<script>

  import {Row, Col,Sidebar, SidebarItem,IndexBar, IndexAnchor, NavBar, Tab, Tabs,Search,Tabbar, TabbarItem,Icon,DropdownMenu, DropdownItem,Empty,Tag} from 'vant';
  import {mapState} from 'vuex';

  export default {
    components: {
      [Tab.name]: Tab,
      [Row.name]: Row,
      [Col.name]: Col,
      [Icon.name]: Icon,
      [Sidebar.name]: Sidebar,
      [SidebarItem.name]: SidebarItem,
      [IndexBar.name]: IndexBar,
      [IndexAnchor.name]: IndexAnchor,
      [NavBar.name]: NavBar,
      [Search.name]: Search,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [Tabs.name]: Tabs,
      [Empty.name]: Empty,
      [Tag.name]: Tag,
    },
    data() {
      return {
        height:'',
        activeKey: -1,
        activeName: '全部',
        value:'',
        currentAgent:'',
        cangku:[],
        //左侧导航栏分类
        category:[],
        //全部耗材品种
        tabbarAll:[],
        parseTabbarAll:[],
        projectErpCode:'',
        warehouse:[],
      };
    },
    computed:{
      ...mapState(['permissionAgent','defaultAgentIndex']),
        classObject: function () {
            return {
                'overflow-y': 'scroll',
                'height': this.height
            }
        }
    },

    methods: {
      onClickLeft() {
        let path = this.$route.params.from;
        let extra = this.$route.params.extra;
        this.$router.push({
          name:path,
          params:{
            extra,
          }
        })
      },
      selectedItem(item) {
        let path = this.$route.params.from;
        let container = this.$route.params.container;
        container.push(item);
        let extra = this.$route.params.extra;
        this.$router.push({
          name:path,
          params:{
            container,
            extra
          }
        })
      },
      onChange(index) {
        this.parseTabbarAll = this.tabbarAll;
        this.value = '';
        let val = this.category[index].category_name;
        this.parseTabbarAll = this.tabbarAll.filter(function(elem){
          return elem.category_name.indexOf(val) > -1;
        });
      },
      changeCk(name,title){
        if(title == '全部') {
          this.value='';
          this.activeKey = -1;
          this.parseTabbarAll = this.tabbarAll;
        }
      },
      initCangku(obj) {
        let newcangku = [{
          warehouse_name:'全部',
        }];
        for (let i = 0; i < obj.length; i++) {
          newcangku.push({
            warehouse_name:obj[i].warehouse_name
          });
        }
        return newcangku;
      },
      initCategory(obj) {
        let newCategory = [];
        if (obj) {
          for(let i = 0;i < obj.length;i++) {
            if(!newCategory.find(
              item=>{
                return item.category_name == obj[i].category_name
              }
            )) {
              newCategory.push({
                category_name : obj[i].category_name,
                category_id : obj[i].category_id
              });
            }
          }
        }
        return newCategory;
      },
      
      onSearch(val){
        this.activeKey = -1;
        this.parseTabbarAll = this.initSearchList(val);
      },
      initSearchList(val) {
        if(!val) {
          return this.tabbarAll;
        } else {
          return this.tabbarAll.filter(function(elem){
            return elem.modelname.indexOf(val) > -1 || elem.brandname.indexOf(val) > -1;
          });
        }
      }
    },
    created() {
      let _this = this
      this.cangku = this.initCangku(this.$route.params.warehouse);
      this.$http.post('/mobile/stockList',{
        projectErpCode:this.$route.params.projectErpCode
      }).then(function (response) {
        _this.category = _this.initCategory(response.stock);
        _this.tabbarAll = response.stock;
        _this.parseTabbarAll = _this.tabbarAll;
      })
    },
    mounted(){
        this.height = (document.documentElement.clientHeight - 240)+"px";
    },

  };
</script>

<style lang="less" scopt>
  #aaa{
    width:100vw;
    height:46px;
  }
  #bbb{
    width:100vw;
    height:40px;
  }
  .van-nav-bar__title{
    font-weight: 800;
    color:#323233;
  }
  .van-nav-bar .van-icon {
    color: rgba(0,0,0,.7);
  }
</style>
